import React from 'react';
import { connect } from 'react-redux';
import { setLocale } from '../../actions/intl';
import { choseToTheme } from '../../actions/currency/getCurrencyRates';
import NAV from './nav';
import PATHS from './icons';
import PushToggle from '../Booking/DirectBookingList/PushToggle';
import { adminLogout } from '../../actions/siteadmin/logout';

const NAV_AR = {
  Overview: 'نظرة عامة', Operations: 'العمليات', People: 'الأشخاص', Money: 'المال',
  Catalogue: 'الكتالوج', Content: 'المحتوى', Communications: 'الاتصالات', System: 'النظام',
  dispatch: 'التوزيع', live: 'الطلبات الجارية', direct: 'الحجوزات المباشرة', scheduled: 'المجدولة',
  completed: 'المكتملة', cancelled: 'الملغاة', tracking: 'التتبع المباشر', customers: 'العملاء',
  providers: 'مقدمو الخدمة', approvals: 'موافقات مقدمي الخدمة', ratings: 'التقييمات والمراجعات',
  payouts: 'الدفعات', failed: 'الدفعات الفاشلة', currency: 'العملات', gateways: 'بوابات الدفع',
  services: 'الخدمات', subservices: 'الخدمات الفرعية', pricing: 'التسعير', areas: 'مناطق الخدمة',
  promos: 'الرموز الترويجية', reasons: 'أسباب الإلغاء', website: 'محتوى الموقع', static: 'الصفحات الثابتة',
  content: 'صفحات المحتوى', push: 'الإشعارات الفورية', precaution: 'إشعارات التنبيه', sms: 'مقدمو SMS',
  site: 'إعدادات الموقع', mobile: 'تطبيقات الجوال', config: 'الإعدادات', admins: 'مشرفو النظام',
  roles: 'الأدوار والصلاحيات', audit: 'سجل التدقيق'
};

/*
 * Kerangka dashboard baru: sidebar 8 grup, topbar, breadcrumb.
 *
 * Hidup di /admin/*. Dashboard lama di /siteadmin/* TIDAK disentuh sama sekali
 * dan tetap berfungsi penuh — client bisa pindah bolak-balik, dan membatalkan
 * seluruh redesign cukup dengan berhenti membuka /admin.
 *
 * Selama layar barunya belum ada, tiap item sidebar melompat ke URL lama (lihat
 * `legacy` di nav.js). Itu yang membuat kerangka ini berguna sejak hari pertama
 * alih-alih jadi cangkang kosong: struktur navigasinya sudah baru, isinya masih
 * lama, dan ditukar satu per satu.
 *
 * Gaya datang dari /css/admin/*.css yang dimuat Html.js untuk route /admin —
 * berkas statis, nama kelas global, sengaja BUKAN css-modules. Lihat catatan di
 * base.css.
 */

export const Icon = ({ name }) => (
  <svg className="ic" viewBox="0 0 24 24" aria-hidden="true">
    {(PATHS[name] || PATHS.grid).map((d, i) => <path key={i} d={d} />)}
  </svg>
);

/*
 * Avatar inisial dan pasangan nama + baris kecil di bawahnya — `U.avatar` dan
 * `U.who` paket client. Kelas .av / .who / .nm / .sub sudah ada di base.css
 * sejak porting pertama; tanpa komponen ini tiap layar menuliskannya sendiri
 * dan tabel pertama saya menulisnya salah (nama dan id sejajar, tanpa avatar).
 */
export const initialsOf = name => String(name || '?')
  .trim().split(/\s+/).slice(0, 2)
  .map(w => w[0] || '').join('').toUpperCase() || '?';

export const Avatar = ({ name, lg }) => (
  <div className={`av${lg ? ' lg' : ''}`} aria-hidden="true">{initialsOf(name)}</div>
);

export const Who = ({ name, sub }) => (
  <div className="who">
    <Avatar name={name} />
    <div style={{ minWidth: 0 }}>
      <div className="nm" dir="auto">{name}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  </div>
);

// Ikon aplikasi yang asli, bukan siluet truk generik — berkas yang sama yang
// dipakai favicon dan header situs publik.
const Logo = () => (
  <span className="logo" aria-hidden="true">
    <img src="/images/site/logo-80.webp" alt="" width="32" height="32" />
  </span>
);

/*
 * Jam Live. Dirender KOSONG di server dan baru diisi setelah mount.
 *
 * Waktu server dan waktu klien tidak pernah persis sama, jadi merendernya di
 * SSR menghasilkan peringatan hidrasi React dan angka yang meloncat sekejap
 * saat halaman hidup. Kosong dulu, lalu diisi, lebih jujur daripada menampilkan
 * waktu yang langsung salah.
 *
 * Zona waktu dipatok Asia/Dubai, bukan zona peramban: ini konsol operasi untuk
 * armada di UAE, dan dispatcher yang sedang bepergian tetap harus melihat jam
 * yang sama dengan sopirnya.
 */
class LiveClock extends React.Component {
  state = { now: null };

  componentDidMount() {
    this.tick();
    this.id = setInterval(this.tick, 30000);
  }
  componentWillUnmount() { clearInterval(this.id); }

  tick = () => {
    this.setState({
      now: new Date().toLocaleTimeString('en-GB', {
        timeZone: 'Asia/Dubai', hour: '2-digit', minute: '2-digit'
      })
    });
  };

  render() {
    return (
      <span className="live">
        <span className="pulse" aria-hidden="true" />
        {this.props.locale === 'ar' ? 'مباشر' : 'Live'} <b>{this.state.now || '--:--'} GST</b>
      </span>
    );
  }
}

class AdminShell extends React.Component {
  state = { navOpen: false, loggingOut: false };

  toggleNav = () => this.setState(s => ({ navOpen: !s.navOpen }));
  closeNav = () => this.setState({ navOpen: false });

  componentDidMount() {
    this.onKey = e => { if (e.key === 'Escape') this.closeNav(); };
    document.addEventListener('keydown', this.onKey);
    try {
      this.navScroll.scrollTop = Number(sessionStorage.getItem('adminNavScroll')) || 0;
    } catch (e) { /* Storage may be disabled; scrolling still works normally. */ }
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKey);
  }

  // Satu tombol, satu action, satu cookie — dipakai bersama dashboard lama.
  toggleTheme = () => {
    this.props.choseToTheme(this.props.theme === 'dark' ? 'light' : 'dark');
  };

  toggleLang = () => {
    this.props.setLocale({ locale: this.props.currentLocale === 'ar' ? 'en-US' : 'ar' });
  };

  handleLogout = async () => {
    if (this.state.loggingOut) return;
    this.setState({ loggingOut: true });
    try {
      await this.props.adminLogout();
    } catch (error) {
      /* Sesinya sudah dibuang server atau jaringannya putus — tetap
         tinggalkan halaman ini, jangan menahan orang di dashboard yang
         mereka kira sudah ditutup. */
    }
    window.location.assign('/login');
  };

  rememberNavScroll = e => {
    try { sessionStorage.setItem('adminNavScroll', String(e.currentTarget.scrollTop)); } catch (error) { /* noop */ }
  };

  renderItem(item) {
    const { current, badges, currentLocale } = this.props;
    const active = item.id === current;
    const count = item.badge && badges ? badges[item.badge] : 0;

    /*
     * Item tanpa layar baru DAN tanpa padanan lama dirender sebagai <span>,
     * bukan <a>. Persetujuan provider butuh kolom UserDocument.status dan
     * documentsReviewedAt yang belum ada; audit log butuh tabelnya dulu.
     * Menautkannya ke mana pun sekarang cuma membuang orang ke halaman kosong.
     */
    if (!item.next && !item.legacy) {
      return (
        <span className="nav-item" key={item.id} aria-disabled="true"
          title="Layarnya belum ada — backend-nya belum dibangun">
          <Icon name={item.icon} />
          <span className="lb">{currentLocale === 'ar' ? (NAV_AR[item.id] || item.label) : item.label}</span>
          <span className="tag">soon</span>
        </span>
      );
    }

    return (
      <a className="nav-item" key={item.id} href={item.next || item.legacy}
        aria-current={active ? 'page' : undefined} onClick={this.closeNav}>
        <Icon name={item.icon} />
        <span className="lb">{currentLocale === 'ar' ? (NAV_AR[item.id] || item.label) : item.label}</span>
        {count > 0 && <span className="nav-badge">{count}</span>}
      </a>
    );
  }

  render() {
    const { title, lead, breadcrumb, actions, children, theme, currentLocale } = this.props;
    const { navOpen } = this.state;
    const isDark = theme !== 'light';   // konsol ini gelap secara bawaan
    const isAr = currentLocale === 'ar';
    const adminName = (this.props.admin && this.props.admin.email) || (isAr ? 'المشرف' : 'Admin');
    const adminRole = (this.props.admin && this.props.admin.roleName)
      || (isAr ? 'تم تسجيل الدخول' : 'Signed in');
    const initials = adminName.slice(0, 2).toUpperCase();
    const replaced = (NAV.reduce((f, g) => f || g.items.find(i => i.id === this.props.current), null) || {}).legacy;

    return (
      <div className="app" data-nav={navOpen ? 'open' : 'closed'}>
        <a className="sr" href="#main">Skip to content</a>

        <nav className="nav" aria-label="Admin">
          <div className="nav-head">
            <Logo />
              <span className="nav-title"><b>Bas Recovery</b><span>{isAr ? 'الإدارة' : 'ADMIN'}</span></span>
          </div>

          <div className="nav-scroll" ref={node => { this.navScroll = node; }} onScroll={this.rememberNavScroll}>
            {NAV.map(g => (
              <div className="nav-grp" key={g.group}>
                <h3>{currentLocale === 'ar' ? (NAV_AR[g.group] || g.group) : g.group}</h3>
                {g.items.map(item => this.renderItem(item))}
              </div>
            ))}
          </div>

          {/* Siapa yang sedang login. Dashboard ini mengubah uang dan status
              provider; tahu akun mana yang sedang dipakai itu bagian dari
              memakainya dengan aman, bukan hiasan. */}
          <div className="nav-foot">
            <span className="logo" aria-hidden="true" style={{ width: 28, height: 28, fontSize: 11 }}>
              {initials}
            </span>
            <span className="who">
              <b>{adminName}</b>
              <span>{adminRole}</span>
            </span>
            {/* Keluar akun. Dashboard lama punya ini di dasar sidebar-nya
                (SideMenu.js); yang baru tidak punya sama sekali, jadi
                satu-satunya cara keluar adalah lewat "Back to classic" dulu.
                Di komputer bersama itu bukan sekadar merepotkan.

                Navigasinya SENGAJA muat ulang penuh, bukan history.push milik
                `adminLogout`: /admin dan /login dirender dengan set CSS yang
                berbeda dan pilihannya cuma dibuat di server (Html.js
                `isAdminNext`), jadi pindah lewat SPA menampilkan layar login
                dengan gaya yang salah. */}
            <button className="btn icon logout" type="button" onClick={this.handleLogout}
              title={isAr ? 'تسجيل الخروج' : 'Log out'}
              aria-label={isAr ? 'تسجيل الخروج' : 'Log out'}>
              <Icon name="logout" />
            </button>
          </div>
        </nav>

        <div className="main">
          <header className="topbar">
            <button className="btn icon nav-toggle" type="button" aria-label="Menu"
              aria-expanded={String(navOpen)} onClick={this.toggleNav}>
              <Icon name="menu" />
            </button>

            <nav className="crumb" aria-label="Breadcrumb">
              {(breadcrumb || []).map((c, i, arr) => (
                <span key={c}>
                  {i > 0 && <i aria-hidden="true">/&nbsp;</i>}
                  {i === arr.length - 1 ? <b>{c}</b> : c}
                </span>
              ))}
              {/* Menyebut layar lama yang digantikan halaman ini, seperti
                  syncCrumb() paket client. Berguna selama dua dashboard masih
                  hidup berdampingan: pembaca tahu apa yang sudah dipindah. */}
              {replaced && <span className="tag">{isAr ? 'يستبدل' : 'replaces'} {replaced}</span>}
            </nav>

            <div className="sp">
              {/* Jalan keluar. Selama redesign belum lengkap, client harus bisa
                  kembali ke dashboard yang dia pakai kerja tiap hari dalam satu
                  klik, dari halaman mana pun. */}
              <a className="btn ghost sm" href="/siteadmin">{isAr ? 'العودة إلى النسخة الكلاسيكية' : 'Back to classic'}</a>

              <PushToggle compact locale={currentLocale} />

              <LiveClock locale={currentLocale} />

              {/* Tombol bahasa mengubah locale untuk SELURUH dashboard, jadi
                  layar-layar lama yang dibuka dari sidebar ikut berganti. Label
                  sidebar baru sendiri masih bahasa Inggris — teksnya ada di
                  nav.js dan belum masuk berkas terjemahan. */}
              <button className="btn icon" type="button" onClick={this.toggleLang}
                title={isAr ? 'Switch to English' : 'التبديل إلى العربية'}
                aria-label={isAr ? 'Switch to English' : 'Switch to Arabic'}>
                <span aria-hidden="true">{isAr ? 'EN' : 'ع'}</span>
              </button>

              <button className="btn icon" type="button" onClick={this.toggleTheme}
                title={isDark ? 'Light mode' : 'Dark mode'}
                aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
                <Icon name={isDark ? 'sun' : 'moon'} />
              </button>
            </div>
          </header>

          <main className="content" id="main">
            <div className="page-h">
              <div>
                <h1>{title}</h1>
                {lead && <p>{lead}</p>}
              </div>
              {actions && <div className="sp">{actions}</div>}
            </div>
            {children}
          </main>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  admin: state && state.account && state.account.data,
  theme: state && state.currency && state.currency.theme,
  currentLocale: state && state.intl && state.intl.locale
});
const mapDispatch = { choseToTheme, setLocale, adminLogout };

export default connect(mapState, mapDispatch)(AdminShell);
